export var EXTERNAL_APPS;
(function (EXTERNAL_APPS) {
    EXTERNAL_APPS["MICHELIN_TRUCK_TIRE"] = "Michelin Truck Tire";
    EXTERNAL_APPS["MICHELINB2B"] = "MichelinB2B";
    EXTERNAL_APPS["PO_EVENT_VIEWER"] = "PO Event Viewer";
    EXTERNAL_APPS["QLIKVIEW"] = "QlikView";
    EXTERNAL_APPS["MICHELIN247"] = "Michelin247";
})(EXTERNAL_APPS || (EXTERNAL_APPS = {}));
export var SALESFORCE_LINKS;
(function (SALESFORCE_LINKS) {
    SALESFORCE_LINKS["PRIVACY_POLICY"] = "https://www.myportal.michelingroup.com/s/privacy-policy";
    SALESFORCE_LINKS["TERMS_OF_USE"] = "https://myportal.michelingroup.com/s/terms-of-use";
})(SALESFORCE_LINKS || (SALESFORCE_LINKS = {}));
//# sourceMappingURL=AppsExternal.js.map